import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CustomAction from 'core/actions/CustomAction'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

export const NEW_CLUSTER_NODE_LABEL = 'kaapi.pf9.io/cluster-name'

const { kubernetes } = ApiClient.getInstance()

export const BYOHostActions = ActionsSet.make<DataKeys.KaapiBYOHosts>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiBYOHosts],
  cacheKey: DataKeys.KaapiBYOHosts,
})

export const listByoHosts = BYOHostActions.add(
  new ListAction<DataKeys.KaapiBYOHosts>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get BYOHosts ', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiBYOHosts)
  }).addDependency(DataKeys.KaapiBYOMachines),
)

export const addClusterLabelToByoHost = BYOHostActions.add(
  new CustomAction<DataKeys.KaapiBYOHosts>(
    'addClusterLabelToByoHost',
    async ({ name, clusterName }) => {
      Bugsnag.leaveBreadcrumb('Attempting to add label to BYOHost ', { name })
      await kubernetes.patchCustomResource({
        type: DataKeys.KaapiBYOHosts,
        name: name as string,
        body: {
          metadata: {
            labels: {
              [NEW_CLUSTER_NODE_LABEL]: clusterName,
            },
          },
        },
        contentType: 'application/merge-patch+json',
      })
    },
  ),
)

export const patchByoHost = BYOHostActions.add(
  new UpdateAction<DataKeys.KaapiBYOHosts>(async ({ name, customBody, contentType }) => {
    Bugsnag.leaveBreadcrumb('Attempting to patch BYOHost ', { name })
    await kubernetes.patchCustomResource({
      type: DataKeys.KaapiBYOHosts,
      name: name as string,
      body: customBody,
      contentType: contentType as string,
    })
  }),
)

export const BYOMachinesActions = ActionsSet.make<DataKeys.KaapiBYOMachines>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiBYOMachines],
  cacheKey: DataKeys.KaapiBYOMachines,
})

export const listByoMachines = BYOMachinesActions.add(
  new ListAction<DataKeys.KaapiBYOMachines>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get BYOMachines ', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiBYOMachines)
  }),
)
